import { Subject } from 'rxjs';

const subject = new Subject();

export const MenuMessageService = {
    sendMenuChangeMessage: (menuName, isOpened) => subject.next({ menuName: menuName, isOpened: isOpened }),
    // send close all menus is sending opening DUMMY_MENU message, that will close all others 
    sendCloseAllMenusMessage: () => subject.next({ menuName: 'DUMMY_MENU', isOpened: true }),
    getMessageChangeMessage: () => subject.asObservable()
};